/* eslint-disable no-param-reassign */
import { Swiper, Navigation, Pagination } from 'swiper';

function choseActiveTab(tab, block, name) {
  tab.classList.add('d-none');

  const outdoorTab = block.querySelector(name);
  if (outdoorTab) {
    outdoorTab.click();
  }
}
function hideEmptyTab(block, tabs, elems) {
  let indoorEls = false;
  let outdoorEls = false;

  elems.forEach((card) => {
    const type = card.getAttribute('data-tag');

    if (type === 'indoor') {
      indoorEls = true;
    }

    if (type === 'outdoor') {
      outdoorEls = true;
    }
  });

  tabs.forEach((tab) => {
    if (tab.classList.contains('venues-cards__tab--indoor') && !indoorEls) {
      choseActiveTab(tab, block, '.venues-cards__tab--outdoor');
    }

    if (tab.classList.contains('venues-cards__tab--outdoor') && !outdoorEls) {
      choseActiveTab(tab, block, '.venues-cards__tab--indoor');
    }
  });
}

document.querySelectorAll('section.venues-cards').forEach((venueCard) => {
  const tabs = venueCard.querySelectorAll('.venues-cards__tab');
  const swiperContainer = venueCard.querySelector('.swiper-container');
  console.log(venueCard);

  // Initialize Swiper only once
  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 3,
    spaceBetween: 20,
    modules: [Navigation, Pagination],
    breakpoints: {
      0: { slidesPerView: 1, allowTouchMove: true, spaceBetween: 20 },
      768: { slidesPerView: 2, spaceBetween: 48 },
      992: { slidesPerView: 3, allowTouchMove: false, spaceBetween: 64 },
    },
    navigation: {
      nextEl: venueCard.querySelector('.swiper-button-next'),
      prevEl: venueCard.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: venueCard.querySelector('.swiper-pagination'),
      clickable: true,
      renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Slide ${index + 1}"></button>`,
    },
    watchSlidesProgress: true,
    watchOverflow: true,
    loop: false,
  });

  swiper.slides.forEach((slide, index) => {
    slide.addEventListener('focus', () => {
      swiper.slideTo(index - 1);
    });
  });

  const filterItems = (type) => {
    const slides = venueCard.querySelectorAll('.venues-cards__item');

    slides.forEach((el) => {
      const matchesType = el.getAttribute('data-tag') === type;

      el.classList.remove('d-block', 'd-none');

      if (matchesType) {
        el.classList.add('d-block');
      } else {
        el.classList.add('d-none');
      }
    });

    hideEmptyTab(venueCard, tabs, slides);
    swiper.update();
  };

  const setActiveTab = (newTab) => {
    const selectedType = newTab.textContent.trim().toLowerCase();

    tabs.forEach((tab) => {
      const isActive = tab === newTab;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-pressed', isActive.toString());
    });

    filterItems(selectedType);
  };

  // Initial filter and Swiper update
  [...tabs].some((tab) => {
    setActiveTab(tab);
    return true;
  });
  swiper.update();

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => setActiveTab(tab));
  });
});
